import type { ReactNode } from 'react';
import type { ButtonProperties } from 'ui';
import { Button, Icon, Tooltip, message } from 'ui';
import { routes as routesAdmin, useAdminDashboardRedirectMutation } from 'features/admin-dashboard';

type P = {
  block?: boolean;
  children?: ReactNode;
  size?: ButtonProperties['size'];
  text?: string;
  tooltip?: string;
  userId?: string;
};

const AdminUserDetailButton = ({ block, children, size, tooltip, userId }: P) => {
  const { isPending: isRedirectingToAdminDashboard, mutate: redirectToAdminDashboard } =
    useAdminDashboardRedirectMutation();

  if (!userId) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <Button
        block={block}
        icon={<Icon icon="user-security-line" />}
        loading={isRedirectingToAdminDashboard}
        onClick={() => {
          message.info('Redirecting to Admin console');
          redirectToAdminDashboard({ referrer: routesAdmin.user.detail(userId) });
        }}
        size={size}
        type="secondary"
      >
        {children}
      </Button>
    </Tooltip>
  );
};

export default AdminUserDetailButton;
